import qs from 'qs';
import { network } from 'services/network';

export const getServerTime = () => {
    const queryString = qs.stringify({ name: location.hostname }, { addQueryPrefix: true, skipNulls: true });
    const url = `admin/bo/getServerTime${queryString}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
